import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userService from "../services/userService";

const initialState = {
  user: {},
  actualScore: 0,
  coins: 0,
  error: null, // Alterado para armazenar a mensagem de erro
  success: false,
  loading: false,
  message: null,
};

export const profile = createAsyncThunk(
  "user/profile",
  async (user, thunkApi) => {
    const token = thunkApi.getState().auth.user.token;
    const data = await userService.profile(user, token);
    return data;
  }
);

export const getAllUsers = createAsyncThunk(
  "user/all",
  async (user, thunkApi) => {
    const data = await userService.getAllUsers();
    return data;
  }
);

export const updateUserCoins = createAsyncThunk(
  "user/coins",
  async (user, thunkAPI) => {
    try {
      // Envia a requisição com credenciais (cookies HttpOnly) automaticamente
      const data = await userService.updateUserCoins(user, { withCredentials: true });

      // Verifica se há erros
      if (data.errors) {
        return thunkAPI.rejectWithValue(data.errors[0]);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Erro ao atualizar o perfil.");
    }
  }
);


export const updateProfile = createAsyncThunk(
  "user/update",
  async (user, thunkAPI) => {
    try {
      // Envia a requisição com credenciais (cookies HttpOnly) automaticamente
      const data = await userService.updateProfile(user, { withCredentials: true });

      // Verifica se há erros
      if (data.errors) {
        return thunkAPI.rejectWithValue(data.errors[0]);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Erro ao atualizar o perfil.");
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.message = null;
    },
    setScore: (state, action) => {
      state.user.actualScore = action.payload;
    },
    setCoins: (state, action) => {
      state.user.coins = action.payload;
    },
    updateCoins: (state, action) => {
      state.user.coins += action.payload.coinsEarned;
    },
    incrementScore: (state, action) => {
      state.user.actualScore += action.payload.score;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(profile.pending, (state) => {
        state.loading = true; // Corrigido para definir `loading` em vez de `profile`
        state.error = null;
      })
      .addCase(profile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.user = action.payload;
      })
      .addCase(profile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Armazena a mensagem de erro
        state.success = false;
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset do erro para uma nova tentativa
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.user = action.payload;
        state.message = "Perfil atualizado com sucesso!";
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload; // Certifique-se de que a API retorna um array.
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetMessage, setCoins, setScore, incrementScore, updateCoins } = userSlice.actions;
export default userSlice.reducer;
